export function resolveItemAvailableQuantity(item) {
    if (!item) {
        return null;
    }

    const fields = ['available', 'remaining', 'stock', 'max'];

    for (let index = 0; index < fields.length; index += 1) {
        const value = item[fields[index]];

        if (value !== null && value !== undefined && value !== '') {
            const numericValue = Number(value);

            if (!Number.isNaN(numericValue) && numericValue >= 0) {
                return numericValue;
            }
        }
    }

    return null;
}

export function formatItemBoolean(value) {
    if (value === null || value === undefined || value === '') {
        return '-';
    }

    return value === true || value === 1 || value === '1' ? 'Yes' : 'No';
}
